import { defineStore, IStoreState } from "@/utils/store"

export const common = defineStore({
  state: {
    lang: '',
    currency: '',
    currencyValue: '',
  },
  mutations: {
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default common
export type ICommonStoreState = IStoreState<typeof common.state>